import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FilterSelector } from '.';
import { filterSelectorState, filterDispatcher, repositoryState, combineStates, pageresultState, combineDispatchers, analyticsDispatcher,
  siteSettingsState, identityState, currentNodeState ,filterSelectedDispatcher} from '../../../../store';
import { PropTypes } from 'prop-types';
import { BusyContainer, SelectionViewer, SvgImage } from '../../../../components';
import { translate, getLanguages, localStore } from '../../../../services';
import { FilterIconNew, ResetSearchIconNew, SearchIconNew, searchIcon } from '../../../../../style/images';
import { TranslationService } from '../../../../util';
import { Badge, Box, Drawer, Icon } from '@mui/material';

const deadValues = ['not applicable', 'not&#032;applicable', 'do not display'];

export class SelectorViewerComponent extends Component {
  constructor(){
    super();
    this.state = {
      CustomerCode: null,
      toggle:false,
      filterCount:0,
      totalFilterCount:0,
      searchInput: "",
    };
  }

  updateTotalFilterCount = (count)=>{
    this.setState({totalFilterCount:count})
  }

  updateFilterCount = (count)=>{
    this.setState({filterCount:count})
  }

  componentDidMount() {
    const { currentSelector, filterSelectors, siteSettings, user } = this.props;
    const selectedFilter = filterSelectors && filterSelectors?.filter(f=> f && f.values && f.values.any(v=>v.isSelected));
    if(selectedFilter && selectedFilter.length==0){
      this.props.setFilterSelected(false);
    }
    else{
      this.props.setFilterSelected(true);
    }
   let count = 0;
    if( siteSettings.filterBasedOnSelectorProperty && currentSelector ){
      currentSelector.sqlFilters ? currentSelector.sqlFilters : currentSelector.sqlFilters = [];
      currentSelector.sqlFilters.forEach((filter) =>{
        if(filter.property=='IsSelectorProduct.' + user.country){
          count+=1;}})
          if(count<0){
            
      currentSelector.sqlFilters.push({
        contains: null,
        equalsTo: "True",
        isUserDefined: false,
        property: "IsSelectorProduct." + user.country,
        startsWith: null
      });    
          }
        }
    ( (!filterSelectors || this.isRelatedFilterUpdated() ) && currentSelector || user.authenticationType === 'PartnerHub') && this.props.getFilterSelectors( currentSelector, user );
    this.setState({CustomerCode:this.props.user.properties.CustomerCode});
    const totalSelectedFilters = filterSelectors?.filter( filter =>filter.properties.Show && !deadValues.includes(filter.name.toLocaleLowerCase( 'en-US' ))&&filter.values.any( v =>!deadValues.includes(v.name?.toLocaleLowerCase( 'en-US' )) && v.isSelected ) );
    totalSelectedFilters&&this.state.totalFilterCount!==totalSelectedFilters.length&&this.updateTotalFilterCount(totalSelectedFilters.length)
  }

  componentDidUpdate(){
    const { currentSelector, filterSelectors, siteSettings, user } = this.props;
    const totalSelectedFilters = filterSelectors?.filter( filter =>filter.properties.Show && !deadValues.includes(filter.name.toLocaleLowerCase( 'en-US' ))&&filter.values.any( v =>!deadValues.includes(v.name?.toLocaleLowerCase( 'en-US' )) && v.isSelected ) );
    totalSelectedFilters&&this.state.totalFilterCount!==totalSelectedFilters.length&&this.updateTotalFilterCount(totalSelectedFilters.length)
  }
  componentWillReceiveProps( nextProps, prevProps ) {
    const { currentSelector, user } = this.props;
    const { CustomerCode } = this.state;
    localStore.set( 'isStockFilterSelected', false  );
    if ( nextProps.currentSelector && currentSelector && nextProps.currentSelector.name !== currentSelector.name ||( CustomerCode && this.props.user.properties.CustomerCode != CustomerCode  ) ) {
      this.props.getFilterSelectors( nextProps.currentSelector, user, true );
    }
    this.setState({CustomerCode:this.props.user.properties.CustomerCode});
    if ( currentSelector.type === 2 && this.searchInput &&
        !currentSelector.sqlFilters.filter( f => !f.property.startsWith( "9AA" ) ).first().equalsTo ){
      this.searchInput.value = '';
    }
  }

  componentWillUnmount(){
    const { currentSelector } = this.props;
    if( currentSelector.type === 2 && this.searchInput){      
      this.searchInput.value = "";
      this.search();
    }
  }

  isRelatedFilterUpdated() {
    const { filterSelectors, relatedFilterSelectors } = this.props;
    if( !relatedFilterSelectors ) {
      return false;
    }

    for( let relatedFilter of relatedFilterSelectors ) {
      for( let filter of filterSelectors ) {
        if( relatedFilter.identifier === filter.identifier ) {
          for( let relatedValue of relatedFilter.values ) {
            for( let value of filter.values ) {
              if( value.name === relatedValue.name && value.isSelected !== relatedValue.isSelected ) {
                return true;
              }
            }
          }
        }
      }
    }

    return false;
  }

  onFilterSelectorsChanged = filterSelector => {
    const { currentSelector, filterSelectors, user, pageresult } = this.props;
    const userSelectedFilters = filterSelectors.filter( filter => filter.isUserAssigned && filter.values.any( v => v.isSelected ) );
    userSelectedFilters.push( filterSelector );
    const totalSelectedFilters = filterSelectors.filter( filter => filter.properties.Show && !deadValues.includes(filter.name.toLocaleLowerCase( 'en-US' ))&& filter.values.any( v => !deadValues.includes(v.name?.toLocaleLowerCase( 'en-US' )) && v.isSelected ) );
    totalSelectedFilters.push( filterSelector );
    this.updateTotalFilterCount(totalSelectedFilters.length)
    this.updateFilterCount(userSelectedFilters.length)
    const userSelectedString = userSelectedFilters.reduce( ( concatenatedString, filter ) =>
      `${ concatenatedString }${ filter.name }$${ filter.values.filter( v => v.isSelected ).map( v => v.name ).join( '-' ) }#`, "" );
    this.props.captureEvent( "selectorSelection", currentSelector.name, userSelectedString, ['commonTracker'] );
    
    const trackSelector = {}
    userSelectedString.split("#").map((item)=>{
      if(item!==""){
        const selector = item.split("$");
        trackSelector[selector[0]] = selector[1];
      }  
    });
   
    //ga4
   
    dataLayer.push({
       'event': "selector_selection",
       event_action: currentSelector.name,
       event_label:userSelectedString,
       event_instance:this.props.siteSettings.properties.GaInstance,
       event_country: this.props.siteSettings.properties.GaCountry,
       location_url:window.location.href
    })
    
    return this.props.updateSelectedValue( filterSelectors, currentSelector, user, filterSelector, 0, pageresult.request.hasStockFilter );
  }

  search = () => {
    if ( !this.searchInput ) {
      return;
    }
    const { currentSelector, filterSelectors, user } = this.props;
    const {culture} = user;
    var lang='';
    if(culture.indexOf('-')>0){
       lang = culture.split( '-' )[0].toUpperCase();
    }
    else{
       lang=culture;
    }
    let value = this.searchInput.value;
    if(value===""){
      value=this.state.searchInput;
    }
    currentSelector?.sqlFilters?.push({
      contains: null,
      equalsTo: value.trim(),
      isUserDefined: true,
      property: "Translation."+lang,
      startsWith: null
    })   
    if( currentSelector.sqlFilters ) {
      currentSelector.sqlFilters = currentSelector.sqlFilters.map( sqlFilter => !sqlFilter.isUserDefined ? sqlFilter : { ...sqlFilter, equalsTo: value.trim() } );

     this.props.updateSelectedValue( filterSelectors, currentSelector, user );
  }}

  onKeyDown = (e) => {if(e.key === 'Enter') {e.target.blur(); this.search();}}

  setSearchInput = input => this.searchInput = input;

  setSearch = e => this.setState({searchInput:e.target.value})

  clearSearch = e => {
    this.searchInput.value = '';
    this.setState({searchInput: ''}, () => {
      this.search();
    });
  };

  renderSearch() {
    return <div className="filter-search-panel">
      <div className="filter-search-input">
        <SvgImage source={ SearchIconNew } onClick={ this.search }/>
        <input value={this.state.searchInput} ref={ this.setSearchInput } onChange={this.setSearch} placeholder={ translate( 'Filter products by...' ) } onKeyDown={ this.onKeyDown }/>
        <Box sx={{width:"16px", height:"16px", background:"transparent", mr:{md:"0px",xs:"8px"}, display:"flex", justifyContent:"center", alignContent:"center", alignItems:"center"}}>
          <SvgImage className="close-icon" source={ ResetSearchIconNew } onClick={ this.clearSearch } />
        </Box>
      </div>
    </div>;
  }

  getTitleforHelpInamge(){
    const {currentNode, filterSelectors} = this.props;
    var title = '';
    if(filterSelectors && currentNode && currentNode.customProperties.customImageFilter){
        const filter = filterSelectors.firstOrDefault(f => f.fullyQualifiedName == currentNode.customProperties.customImageFilter);
        if(filter && filter.values.firstOrDefault(v => v.isSelected)){
          title = filter.values.firstOrDefault(v => v.isSelected).name;
        }
    }

    return title;
  }



  onToggle = ()=>{
    this.setState({toggle:!this.state.toggle})
  }

  render() {
    const { complexFilterComponents = [], currentSelector, filterSelectors, selectorName, looseAccessoryType4 } = this.props;
    const translationService = TranslationService( selectorName, 'selector' )( getLanguages().first() );
    const customeFilteImageTitle = this.getTitleforHelpInamge();
    if(filterSelectors && !this.props.showResetHeader && this.props.setShowResetHeader && currentSelector.type !== 2){
      this.props.setShowResetHeader()
    }
    const filters = filterSelectors && filterSelectors.map( translationService.withValues.bind( translationService ) ).map( ( item, index ) => 
      <FilterSelector 
        selectorName={ selectorName } 
        filter={ item } 
        filterSelectors = { filterSelectors }
        key={ item.identifier + index } 
        onFilterSelectorsChanged={ this.onFilterSelectorsChanged }
        customeFilteImageTitle = {customeFilteImageTitle}
        currentSelector= {currentSelector}
      /> 
    );

    const onlySearch = ( !filters || !filters.length ) && currentSelector.type === 2;

    return<>{!filters || !filters.length && !onlySearch ? null :<>
        <Box sx={{display:{md:"flex", xs:"none"}}}>
          <SelectionViewer className={ onlySearch ? 'search-page' : '' } totalFilterCount={this.state.totalFilterCount} onClose={this.props.onClose}>
            { complexFilterComponents }
            {/* { complexFilterComponents.length ? <hr /> : null } */}
            { filters }
            { currentSelector.type === 2 && this.renderSearch() }
          </SelectionViewer>
        </Box>
        <Box sx={{display:{md:"none", xs:"flex"}}}>
          <div className='filter'>
          { currentSelector.type !== 2 || looseAccessoryType4 ?<div className='filter-box'>
              <span className='filters-header'>{translate("Filters")}</span>
              <Box sx={{width:"max-content", height:"max-content"}} onClick={this.onToggle}>
                <Badge badgeContent={this.state.totalFilterCount > 0 && <span className="badge">{ this.state.totalFilterCount }</span>}>
                  <Icon component="img" src={FilterIconNew} sx={{width:"16px", height:"16px"}}></Icon>
                </Badge>
              </Box>
            </div>:  <SelectionViewer className={ onlySearch ? 'search-page' : '' } totalFilterCount={this.state.totalFilterCount} searchFilter={currentSelector.type === 2} onClose={this.props.onClose}>
                { complexFilterComponents }
                {/* { complexFilterComponents.length ? <hr /> : null } */}
                { filters }
                { currentSelector.type === 2 && this.renderSearch() }
              </SelectionViewer>}
              
          </div>
          <Drawer
                BackdropProps={{ invisible: true }}
                anchor="bottom"
                open={this.state.toggle}
                onClose={this.onToggle}
                PaperProps={{sx:{height:"100vh", position:"unset"}}}
            >
              <BusyContainer actions={["filter-active"]}>
                <SelectionViewer className={ onlySearch ? 'search-page' : '' } currentSelector={currentSelector} onClose={this.onToggle} resetHeader={this.props.resetHeader}>
                  { complexFilterComponents }
                  {/* { complexFilterComponents.length ? <hr /> : null } */}
                  { filters }
                  { currentSelector.type === 2 && this.renderSearch() }
                </SelectionViewer>
              </BusyContainer>
            </Drawer>
        </Box>
        </>}
      </>
  }
}

SelectorViewerComponent.propTypes = {
  complexFilterComponents: PropTypes.arrayOf( PropTypes.node ),
  currentSelector: PropTypes.shape( {
    name: PropTypes.string.isRequired
  } ),
  filterSelectors: PropTypes.arrayOf( PropTypes.object ), 
  getFilterSelectors: PropTypes.func.isRequired,
  pageresult: PropTypes.shape( {
    page: PropTypes.number.isRequired,
    reguest: PropTypes.shape( {
      filterGroups: PropTypes.array.isRequired
    } ),
    results: PropTypes.array,
    totalItems: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired
  } ),
  selectorName: PropTypes.string.isRequired,
  updateSelectedValue: PropTypes.func.isRequired
};

export const SelectorViewer = name => connect( 
  combineStates( filterSelectorState( 'selector' )( name ), pageresultState( 'products' )( name ), repositoryState( 'selector' ), siteSettingsState, identityState, currentNodeState ), 
 combineDispatchers( filterDispatcher, analyticsDispatcher,filterSelectedDispatcher) 
)( SelectorViewerComponent );
